<div fxLayout="column" fxFlex="grow" class="dialog__container">
    <div class="actions">
      <p>{{data.inputMessage}}</p>
    </div>
    <div class="actions" fxLayout="row" fxLayoutAlign="center" fxLayoutGap="30px" fxLayout.xs="column"
      fxLayout.sm="column">
      <button fxFlex="40" mat-button color="primary" (click)="closeDialog(false)">{{data.button2}}</button>
      <button fxFlex="40" mat-raised-button color="primary" (click)="closeDialog(true)">{{data.button1}}</button>
    </div>
  </div>